import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import withInfiniteScroll from 'global/components/withInfiniteScroll';
import { List, Icon, FormControlLabel } from '@material-ui/core';
import Row from './row';
import useStyles from './styles';
import clsx from 'clsx';
import { get, size } from 'global/lib/lodash';
import { useSelector, useDispatch } from 'react-redux';
import Switch from 'global/components/switch';
import { clearNewAlerts, getAlerts, getAllAlerts } from 'redux/actions/view';
import setFilter from 'redux/actions/setFilter';

const TableHeader = (props) => {
  const classes = useStyles({ showLocation: props.showLocation });

  return (
    <div className={clsx(classes.row, classes.headerRow)}>
      <div className={classes.info}>
        <div className={clsx(classes.type, classes.headerHide)}>Type</div>
        {props.showLocation && <div className={clsx(classes.location, classes.headerHide)}>Location</div>}
        <div className={classes.description}>Description</div>
      </div>
      <div className={classes.time}>Time</div>
    </div>
  );
};

// const pageSize = 25;
export default forwardRef((props, ref) => {
  const page = get(props, 'match.path') === '/alerts/user' ? 'user' : 'all';

  const hasRealm = useSelector((state) => get(state, 'auth.realm'));
  const alerts = useSelector((state) => get(state, `view.alerts.${page}`));
  const newAlerts = useSelector(state => get(state, 'view.alerts.new'));
  const filter = useSelector((state) => get(state, `filter.alerts.${page}`));
  const { locationOn } = filter;

  const [showLocation] = useState(page === 'user' ? false : true);
  const [data, setData] = useState(alerts);
  const [origRealm] = useState(hasRealm);
  const [loading, setLoading] = useState(false);
  const [paginate, setPaginate] = useState(1);

  const showRealmFilter = get(props, 'showRealmFilter', true);

  const dispatch = useDispatch();
  const classes = useStyles({ locationOn });

  const clearAll = get(props, 'clearAll', true);

  const getPageAlerts = async () => {
    try {
      setLoading(true);
      const method = page === 'all' ? getAllAlerts : getAlerts;
      await dispatch(method(paginate));
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const filterAlerts = () => {
    if (locationOn && hasRealm && showRealmFilter) {
      return alerts.filter((a) => get(a, 'realms.0.id') == hasRealm.id);
    } else {
      return alerts;
    }
  };

  useEffect(() => {
    getPageAlerts();
  }, [paginate]);

  useEffect(() => {
    setPaginate(1);
  }, [page]);

  useEffect(() => {
    setData(filterAlerts());
  }, [alerts]);

  useEffect(() => {
    if (clearAll && size(newAlerts)) {
      dispatch(clearNewAlerts());
    }
  }, [newAlerts]);

  const setLocationOn = (value) => {
    dispatch(setFilter('alerts', page, { ...filter, locationOn: value }));
  };

  useEffect(() => {
    if (!hasRealm) {
      setLocationOn(false);
    } else if (hasRealm && hasRealm.id !== get(origRealm, 'id')) {
      setLocationOn(true);
    }
  }, [hasRealm]);

  useEffect(() => {
    setData(filterAlerts());
  }, [locationOn, hasRealm]);

  const locationText = () => {
    if (locationOn) {
      return (
        <span>
          Showing only alerts from <b>{hasRealm.name}</b> based on your current location.
        </span>
      );
    } else {
      return `Showing all alerts, even though your current location is set to ${hasRealm.name}.`;
    }
  };

  const handleLocation = (e) => {
    setLocationOn(e.target.checked);
  };

  const updatePage = (newPage) => {
    if (newPage > paginate) {
      setPaginate(newPage);
    }
  };

  useImperativeHandle(ref, () => ({
    getPageAlerts,
  }), []);

  return (
    <div className={classes.container}>
      {hasRealm && showRealmFilter && (
        <div className={classes.locationContainer}>
          <div className={classes.locationContent}>
            <p>{locationText()}</p>
            <FormControlLabel control={<Switch checked={!!get(filter, 'locationOn')} onChange={handleLocation} />} label="USE LOCATION" />
          </div>
          <Icon>place</Icon>
        </div>
      )}

      <ListWithPages
        {...props}
        header={<TableHeader showLocation={showLocation} />}
        data={data}
        loading={loading}
        showLocation={showLocation}
        handlePageChange={updatePage}
        alwaysReplaceData
        currentPage={paginate}
      />
    </div>
  );
});

const ListWithPages = withInfiniteScroll(Row, List);
